import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "new",
  "use": "new-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"new\">\n<rect width=\"18\" height=\"18\" rx=\"3\" fill=\"#F8F1F1\" />\n<path d=\"M11.0187 4.5V10.2129H10.9344L6.75176 4.5H5V13.5H6.99063V7.78271H7.06089L11.2763 13.5H13V4.5H11.0187Z\" fill=\"#EF0000\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol